// extracted by css-extract-rspack-plugin
export default {"FilterButton":"repository-filter-actions-module__FilterButton__kSEV_","LabelColorIndicator":"repository-filter-actions-module__LabelColorIndicator__GTUpE"};